// Campus photo for /colleges/wayne-state-university: CC BY-SA 4.0, by Matt Joseph, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3A2025-07-23_-_McGregor_Memorial_Conference_Center_in_Detroit_MI_US_1.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/wayne-state-university/; credited under the photo.
const photo = {
    "slug": "wayne-state-university",
    "alt": "The McGregor Memorial Conference Center beside its reflecting pool and sculptures on the Wayne State University campus in Detroit, Michigan",
    "src": "/colleges/wayne-state-university/campus-1600.webp",
    "srcSmall": "/colleges/wayne-state-university/campus-800.webp",
    "srcMid": "/colleges/wayne-state-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/wayne-state-university/og.jpg",
    "title": "2025-07-23 - McGregor Memorial Conference Center in Detroit MI US 1",
    "author": "Matt Joseph",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3A2025-07-23_-_McGregor_Memorial_Conference_Center_in_Detroit_MI_US_1.jpg",
    "read": "2026-10-01"
};

export default photo;
